<template>
  <div class="admin-page">
    <Header />
    <div class="header-actions">
      <h2 class="title"><i class="fa-solid fa-tags"></i> Tabela de Preços (Base)</h2>
      <router-link to="/admin/dashboard" class="btn-back">Voltar ao Painel</router-link>
    </div>

    <div class="card-panel">
      <p class="panel-desc">Defina os valores unitários que serão utilizados pela Calculadora de Vendas para montar os pacotes das Instituições.</p>
      
      <div class="pricing-grid">
        <!-- Pacotes Completos -->
        <div class="pricing-card">
          <h3><i class="fa-solid fa-box-open"></i> Pacotes Completos</h3>
          <div class="form-group">
            <label>Todos os Livros (por acesso)</label>
            <input type="number" v-model="prices.full_books" class="input-price" />
          </div>
          <div class="form-group">
            <label>Todos os Vídeos (por acesso)</label>
            <input type="number" v-model="prices.full_videos" class="input-price" />
          </div>
          <div class="form-group">
            <label>Todos os Simulados (por acesso)</label>
            <input type="number" v-model="prices.full_simulated" class="input-price" />
          </div>
          <div class="form-group">
            <label>Combo Total VIP (por acesso)</label>
            <input type="number" v-model="prices.combo_vip" class="input-price" />
          </div>
        </div>

        <!-- Avulsos / Individuais -->
        <div class="pricing-card">
          <h3><i class="fa-solid fa-cube"></i> Materiais Individuais</h3>
          <div class="form-group">
            <label>Livro Avulso (por un/acesso)</label>
            <input type="number" v-model="prices.single_book" class="input-price" />
          </div>
          <div class="form-group">
            <label>Vídeo Avulso (por un/acesso)</label>
            <input type="number" v-model="prices.single_video" class="input-price" />
          </div>
          <div class="form-group">
            <label>Simulado Avulso (por un/acesso)</label>
            <input type="number" v-model="prices.single_simulated" class="input-price" />
          </div>
        </div>

        <!-- Tabela de Faixas por Volume -->
        <div class="pricing-card full-width">
          <div class="card-header-flex">
            <h3><i class="fa-solid fa-layer-group"></i> Descontos por Faixa de Volume (Lotes)</h3>
            <button class="btn-secondary" @click="addTier"><i class="fa-solid fa-plus"></i> Nova Faixa</button>
          </div>
          
          <div class="tiers-table-container">
            <table class="tiers-table">
              <thead>
                <tr>
                  <th>Mín. Acessos</th>
                  <th>Máx. Acessos</th>
                  <th>Desconto Aplicado (%)</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(tier, index) in volumeTiers" :key="index">
                  <td><input type="number" v-model="tier.min" class="input-price tier-input" /></td>
                  <td><input type="number" v-model="tier.max" class="input-price tier-input" /></td>
                  <td>
                    <div class="discount-wrapper">
                      <input type="number" v-model="tier.discount" class="input-price tier-input" />
                      <span>% OFF</span>
                    </div>
                  </td>
                  <td class="actions-cell">
                    <button class="btn-delete" @click="removeTier(index)" title="Remover"><i class="fas fa-trash"></i></button>
                  </td>
                </tr>
                <tr v-if="volumeTiers.length === 0">
                  <td colspan="4" class="empty-state">Nenhuma faixa cadastrada. O preço base será cobrado integralmente.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="action-footer">
        <button class="btn-primary" @click="savePrices">Salvar Configurações</button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import requestV2 from '@/router/requestV2.js';
import '@/styles/Admin.css';

export default {
  name: 'AdminPricing',
  components: { Header },
  data() {
    return {
      loading: true,
      prices: {
        full_books: 150.00,
        full_videos: 200.00,
        full_simulated: 80.00,
        combo_vip: 350.00,
        single_book: 25.00,
        single_video: 35.00,
        single_simulated: 15.00
      },
      volumeTiers: [
        { min: 1, max: 100, discount: 0 },
        { min: 101, max: 500, discount: 10 },
        { min: 501, max: 1000, discount: 20 }
      ]
    }
  },
  async mounted() {
    await this.loadPricing();
  },
  methods: {
    async loadPricing() {
      try {
        const response = await requestV2.get('/pricing');
        const data = response.data;

        if (data.prices && Object.keys(data.prices).length > 0) {
          this.prices = { ...this.prices, ...data.prices };
        }
        if (data.volumeTiers && data.volumeTiers.length > 0) {
          this.volumeTiers = data.volumeTiers;
        }
      } catch (err) {
        console.error('Erro ao carregar preços da API:', err);
        // Fallback: tenta localStorage
        const savedPrices = localStorage.getItem('admin_prices');
        if (savedPrices) {
          try { this.prices = { ...this.prices, ...JSON.parse(savedPrices) }; } catch (e) { /* ignore */ }
        }
        const savedTiers = localStorage.getItem('admin_tiers');
        if (savedTiers) {
          try { this.volumeTiers = JSON.parse(savedTiers); } catch (e) { /* ignore */ }
        }
      } finally {
        this.loading = false;
      }
    },
    addTier() {
      const lastMax = this.volumeTiers.length > 0 
        ? Number(this.volumeTiers[this.volumeTiers.length - 1].max) 
        : 0;
      this.volumeTiers.push({ min: lastMax + 1, max: lastMax + 100, discount: 0 });
    },
    removeTier(index) {
      this.volumeTiers.splice(index, 1);
    },
    async savePrices() {
      try {
        await requestV2.put('/pricing', {
          prices: this.prices,
          volumeTiers: this.volumeTiers
        });
        // Mantém localStorage como cache para o Simulator
        localStorage.setItem('admin_prices', JSON.stringify(this.prices));
        localStorage.setItem('admin_tiers', JSON.stringify(this.volumeTiers));
        alert("Tabela de preços e faixas salvas com sucesso!");
      } catch (err) {
        console.error('Erro ao salvar preços:', err);
        alert("Erro ao salvar preços. Tente novamente.");
      }
    }
  }
}
</script>

<style scoped>
.pricing-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-top: 20px;
}

.pricing-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
}

.pricing-card h3 {
  color: #FEC401;
  margin-bottom: 20px;
  font-size: 1.2rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 10px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #fff;
  margin-bottom: 5px;
  font-size: 0.9rem;
}

.input-price {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  font-family: inherit;
}

.action-footer {
  margin-top: 30px;
  text-align: right;
}

.btn-primary {
  background: #FEC401;
  color: #09105D;
  border: none;
  padding: 12px 24px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.btn-primary:hover {
  transform: translateY(-2px);
  background: #e5b001;
}

.pricing-card.full-width {
  grid-column: 1 / -1;
}

.card-header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 10px;
}

.card-header-flex h3 {
  margin-bottom: 0;
  border-bottom: none;
  padding-bottom: 0;
}

.btn-secondary {
  background: rgba(255,255,255,0.1);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.2);
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover {
  background: rgba(255,255,255,0.2);
}

.tiers-table-container {
  overflow-x: auto;
}

.tiers-table {
  width: 100%;
  border-collapse: collapse;
}

.tiers-table th, .tiers-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}

.tiers-table th {
  color: #ccc;
  font-size: 0.9rem;
}

.tier-input {
  width: 100px;
  padding: 8px;
}

.discount-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.discount-wrapper span {
  color: #FEC401;
  font-weight: bold;
}

.actions-cell {
  text-align: center;
}

.btn-delete {
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  cursor: pointer;
}

.btn-delete:hover {
  background: #d9363e;
}

@media (max-width: 768px) {
  .pricing-grid {
    grid-template-columns: 1fr;
  }
  .pricing-card.full-width {
    grid-column: 1;
  }
}
</style>
